import { connect } from "react-redux";
import { ExportMap, ExportMapDispatchProps, ExportMapProps } from "./ExportMap";
import { RootState } from "../rootState";
import { getOutputFormatsSelector } from "./redux/selectors/getOutputFormats.selector";
import { layersSelector } from "./redux/selectors/layers.selector";
import { getFile } from "./util/ExportMapUtil";

const mapStateToProps = (state: RootState): ExportMapProps => {
    return {
        enabled: true,
        outputFormats: getOutputFormatsSelector(state),
        bbox: state.map?.present?.bbox,
        gisServerUrl: state.layerOptions.gisServerUrl,
        layers: layersSelector(state),
        getFile: getFile,
    };
};

const mapDispatchToProps = (): ExportMapDispatchProps => {
    return {};
};

export const ConnectedExportMap = connect(mapStateToProps, mapDispatchToProps)(ExportMap);
